import { Badge, Box, Button, Chip, Dialog, DialogActions, DialogContent, Grid, IconButton, Paper, Stack, TextField, Typography, useTheme } from '@mui/material'
import React from 'react'
import { CalendarIcon, CheckBoxIcon, CheckedBoxIcon, ClockIcon, CloseLineIcon, DeleteIcon, EmailIcon, LocationIcon, PhoneIcon, PlusIcon, UserIcon } from '../../components/IconComponent'
import { useTranslation } from 'react-i18next';
import CardComponent from '../../components/Card';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { emptyStringIfNull, formatDateToDDMMYYYYFrEpoch, formatDateToDDMMYYYYHHSSFrEpoch, getCustomFieldByKey } from '../../utils/util'
import LinkComponent from '../../components/Link';
export default function InstallationDetailView(props) {
    const { orderDetail, activities, files, setShowUploadFile } = props;
    const { t } = useTranslation();
    const { palette } = useTheme();
    console.log('orderDetail:', orderDetail);
    let items = orderDetail ? dataUtil.createItemsWithComponents(orderDetail.items) : [];
    console.log('items:', items);
    console.log('activity:', activities);

    const renderStatus = (status) => {
        let label = t(status);
        let color = status == 'COMPLETED' ? 'success' : 'warning'
        return <Chip label={label} variant='customOutlined' size='small' color={color} />
    }

    const checkActionOrder = () => {
        let isActionUpdateOrder = true;
        let filterActivityPending = activities.filter(a => {
            return a.state == 'PENDING'
        })
        if (filterActivityPending && filterActivityPending.length > 0) {
            isActionUpdateOrder = false;
        }
        return isActionUpdateOrder;
    }

    let addingDevice = getCustomFieldByKey(orderDetail.custom_fields, "adding_device");
    let isActionUpdateOrder = checkActionOrder();
    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth={"md"}
            sx={{ '& .MuiDialog-paper': { padding: '0px 0px' } }}
        >
            <Stack width={'100%'} height={60} flexDirection={'row'} justifyContent={'flex-start'} alignItems={'center'} paddingX={2}>
                <IconButton onClick={() => props.onClose()}>
                    <CloseLineIcon />
                </IconButton>
                <Typography variant='body1' marginLeft={1} marginRight={1}>Order {orderDetail.number}</Typography>
                {renderStatus(orderDetail.state)}
                {orderDetail.stage && <Stack marginLeft={1}><Chip label={orderDetail.stage.name} variant='customOutlined' size='small' /></Stack>}
            </Stack>
            <DialogContent dividers={true} sx={{
                padding: '0px 0px'
            }}>
                <Grid xs={12} item container direction={'row'} spacing={2} paddingX={2} paddingY={2}>
                    <Grid xs={12} md={6} item>
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2}>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                <UserIcon />
                                {orderDetail.contact && <Stack>
                                    <Typography variant='subtitle2'>{orderDetail.contact.name}</Typography>
                                    <Typography variant='subtitle1' sx={{
                                        border: '1px solid',
                                        borderColor: palette.border.main,
                                        paddingX: 0.5,
                                        paddingY: 0,
                                        fontSize: 12,
                                        borderRadius: 1
                                    }}>{orderDetail.contact.code}</Typography>
                                </Stack>}
                            </Stack>
                            {orderDetail.contact && orderDetail.contact.email_address && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                <EmailIcon />
                                <Typography variant='subtitle2'>{orderDetail.contact.email_address}</Typography>
                            </Stack>}
                            {orderDetail.contact && orderDetail.contact.phone_number && <Stack flex={1} direction={'row'} spacing={1} marginTop={1}>
                                <PhoneIcon />
                                <Typography variant='subtitle2'>{orderDetail.contact.phone_number}</Typography>
                            </Stack>}
                            {orderDetail.contact_address && <Stack flex={1} direction={'row'} spacing={1} mt={1}>
                                <LocationIcon />
                                <Typography variant='subtitle2'>{orderDetail.contact_address.address_line_1 +
                                    emptyStringIfNull(orderDetail.contact_address.address_line_2) +
                                    emptyStringIfNull(orderDetail.contact_address.state_province_county) +
                                    emptyStringIfNull(orderDetail.contact_address.town_city) +
                                    emptyStringIfNull(orderDetail.contact_address.postal_code)}
                                </Typography>
                            </Stack>}
                        </Grid>
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                            <Typography marginBottom={1} variant='subtitle1'>{"Product"}</Typography>
                            {items.map((i, index) => {
                                if (i.product && i.product.classification != "EXPENSES_SERVICE") {
                                    return <Stack key={index} flex={2}>
                                        <Stack direction={'row'} spacing={1} alignItems={'flex-end'}>
                                            <Typography variant='subtitle2'>{i.quantity} x </Typography>
                                            <Typography variant='subtitle2'>{i.product.name}</Typography>
                                        </Stack>
                                    </Stack>
                                } return null;
                            })}
                        </Grid>
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={2} marginTop={2}>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                <CalendarIcon />
                                {orderDetail.key_dates && <Typography variant='subtitle2'>{"Submitted on "}{formatDateToDDMMYYYYHHSSFrEpoch(orderDetail.key_dates.submitted_on)}</Typography>}
                            </Stack>
                            <Stack flex={1} direction={'row'} spacing={1}>
                                {addingDevice && addingDevice == '1' ? <CheckedBoxIcon /> : <CheckBoxIcon />}
                                <Typography variant='subtitle2'>{t('adding_device')}</Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid xs={12} md={6} item >
                        <Grid xs={12} item component={Paper} paddingX={2} paddingY={1}>
                            <Stack flex={1} padding={1} borderBottom={1} borderColor={palette.border.main}>
                                <Typography variant='subtitle1'>{"Activities"}</Typography>
                            </Stack>
                            {activities.map((activity, index) => {
                                const customFieldNote = getCustomFieldByKey(activity.custom_fields, 'notes');
                                console.log("activities.map files:", files);
                                let _files = files.filter(f => {
                                    return f.activity_id == activity.id
                                })
                                console.log("activities.map _files:", _files);
                                let filesUpload = _files && _files.length > 0 ? _files[0].filesUpload : [];
                                console.log("activities.map filesUpload:", filesUpload);
                                return (
                                    <Stack flex={1} paddingY={2} key={index} borderBottom={activities.length - 1 > index ? 1 : undefined} borderColor={palette.border.main}>
                                        <Stack flex={1} direction={'row'} marginBottom={1} spacing={1}>
                                            {renderStatus(activity.state)}
                                            <Chip label={activity.type.name} variant='customOutlined' size='small' sx={{ backgroundColor: activity.type.colour, color: "#FFFFFF" }} />
                                            <Typography variant='subtitle1'>{activity.name}</Typography>
                                        </Stack>
                                        {activity.description && <Stack marginBottom={1}>
                                            <Typography variant='subtitle2'>{t('description') + ':'}</Typography>
                                            <Typography variant='subtitle2'>{activity.description}</Typography>
                                        </Stack>}
                                        <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                                            <CalendarIcon />
                                            <Typography variant='subtitle2'>{t('created_date') + ': '}</Typography>
                                            <Typography variant='subtitle2'>{formatDateToDDMMYYYYHHSSFrEpoch(activity.created_date)}</Typography>
                                        </Stack>
                                        <Stack direction={'row'} spacing={1} marginBottom={0.5}>
                                            <ClockIcon />
                                            <Typography variant='subtitle2'>{t('scheduled_date') + ': '}</Typography>
                                            <Typography variant='subtitle2'>{formatDateToDDMMYYYYFrEpoch(activity.date) + (activity.from_time ? ` at ${activity.from_time}` : ' All day') + (activity.to_time ? ` - ${activity.to_time}` : '')}</Typography>
                                        </Stack>
                                        <Stack flex={1}>
                                            <Typography marginBottom={0.5} variant='subtitle2'>{t('notes') + ': '}</Typography>
                                        </Stack>
                                        <TextField
                                            type={'text'}
                                            multiline={true}
                                            rows={3}
                                            onChange={(event) => props.onChangeNote(activity, event)}
                                            defaultValue={customFieldNote}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    paddingX: 2,
                                                    paddingY: 1
                                                },
                                                '.MuiOutlinedInput-input': {
                                                    padding: 0
                                                }
                                            }}
                                            disabled={activity.state == "COMPLETED"}
                                        />
                                        {activity.state != "COMPLETED" && <Stack sx={{ cursor: 'pointer' }} direction={'row'} mt={2} spacing={1}
                                            border={'1px solid ' + palette.border.main}
                                            px={2} py={1}
                                            borderRadius={1}
                                            onClick={() => props.onShowUploadFile(activity)}>
                                            <Stack flex={1}>
                                                <Typography variant='subtitle1'>{t('attach_files')}</Typography>
                                            </Stack>
                                            <Stack direction={'row'} flex={0.2} justifyContent='flex-end'>
                                                <PlusIcon />
                                            </Stack>
                                        </Stack>}

                                        {activity.file && activity.file.file && activity.file.file.name &&
                                            <Stack flex={1} spacing={0.5} marginTop={1}>
                                                <Typography variant='subtitle1'>{"Files:"}</Typography>
                                                <LinkComponent onClick={() => props.onShowFile(activity.file.file)} color="blue">{activity.file.file.name}</LinkComponent>
                                            </Stack>}
                                        <Grid item container xs={12} marginTop={2}>
                                            {filesUpload.length > 0 && filesUpload.map((f, i) => {
                                                return (
                                                    <Box key={i} position={'relative'} width={48} height={48} marginRight={1}>
                                                        <img alt={f.name} src={f.uri} width={48} height={48} />
                                                        <Box position={'absolute'} right={0} top={0} onClick={() => props.onDeleteFile(activity, f)}>
                                                            <Box display={'flex'} my={0.5} mx={0.5} justifyContent={'center'} alignItems='center' width={25} height={25} borderRadius={1} backgroundColor={palette.background.main}>
                                                                <DeleteIcon size={'18px'} />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )
                                            })}
                                        </Grid>
                                        {activity.state != "COMPLETED" && <Stack flex={1} marginTop={2} justifyContent={'flex-start'} alignItems={'flex-start'}>
                                            <Button size='small'
                                                sx={{ height: 32, backgroundColor: activity.type && activity.type.colour ? activity.type.colour : palette.info.main }}
                                                variant='contained'
                                                onClick={() => props.onCompleteActivity(activity)}>{t('complete_activity')}</Button>
                                        </Stack>}
                                        {props.updateActivitiesNote && props.updateActivitiesNote.message && <Typography variant='subtitle2' color={'error'}>{props.updateActivitiesNote.message}</Typography>}
                                    </Stack>
                                )
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid xs={12} item container direction={'row'} paddingX={2} paddingY={1} justifyContent={'center'}>
                    {isActionUpdateOrder ?
                        <Button sx={{ marginRight: 2 }} variant='contained' onClick={props.onCompleteOrder}>{t('complete_order')}</Button> :
                        <Button sx={{ marginRight: 2 }} variant='contained' onClick={props.onCompleteAllActivity}>{t('complete_all_activity')}</Button>
                    }
                    <Button variant='contained' onClick={() => props.onClose()}
                        sx={{
                            backgroundColor: palette.info.main
                        }}
                    >{t('btn_back')}</Button>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}
